import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import ComingSoon from './components/ComingSoon'
import Collapsible from './components/collapsible'
import Spinner from './components/Spinner'
import Modal from './components/Modal'
import Button from './components/Button'
import vSelect from 'vue-select'
import VueGoodTablePlugin from 'vue-good-table'
import VueI18n from 'vue-i18n'

import 'vue-select/dist/vue-select.css'
import 'vue-good-table/dist/vue-good-table.css'
import './assets/styles/index.css'

Vue.use(VueI18n)
Vue.use(VueGoodTablePlugin)
Vue.config.productionTip = false

const messages = {
    ja: {
        'Login Email': 'ログインメール',
        'Migrate User To Email': 'FBからメールに移行',
        'Giv Pause Time': 'giv停止時間',
        'No Filter': 'フィルターなし',
        'Filter by Giv Type': '贈りたいgivフィルター',
        'Filter by Group': 'グループフィルター',
        'Giv Send Preference': '贈りたいgiv',
        'Giv Receive Preference': '受け取りたいgiv',
        'Groups': 'グループ',
        'Givs Given': '贈ったGiv',
        'Givs Received': '受け取ったGiv',
        'Inactive Users': 'Inactiveユーザー',
        'metric-likes': '新しいLike',
        'metric-commentReactions': '新しいReactions',
        'metric-skills': '新しいスキル',
        'metric-users': '新しいユーザー',
        'metric-posts': 'サンクスカード',
        'metric-givs': 'giv',
        'metric-sendRequests': '贈りたいリクエスト',
        'metric-receiveRequests': '受け取りたいリクエスト',
        'metric-comments': 'コメント',
        'metric-areas': '新しい場所',
        'Group Name': 'グループ名',
        'Select Chat Members': 'チャットメンバー選んでください',
        'Select Moderators (Upto 5)': 'モデラート選んでください(最大5)',
        'Chat Groups': 'チャットグループ',
        'Giv Created': 'Givあり',
        'Delete Request': 'リクエストを削除？',
        'Match': 'マッチ',
        'Likes': 'いいね',
        'Reactions': 'コメントReactions',
        'Memo': 'メモ',
        'Dashboard': 'ダッシュボード',
        'Givs': 'Givs',
        'Thanks Cards': 'TCカード',
        'ThanksCard Views': 'TCカード表示数',
        'Notifications': 'お知らせ',
        'Operator Comment': 'Operator コメント',
        'Kind': 'Kind',
        'Comments': 'コメント',
        'Users': 'ユーザー',
        'Want Sends': 'Giv贈りたい',
        'Want Receives': 'Giv受け取りたい',
        'Invites': '招待コード',
        'Invite User': 'ユーザー登録',
        'Delete': '削除する',
        'Delete Giv': 'Givを削除する',
        'Yes Delete': 'はい、削除する',
        'Cancel': '取り消し',
        'canceled': 'canceled',
        'finished': '終了',
        'planned': '予定',
        'Areas': '場所',
        'Time List': '時間帯',
        'Skills': 'スキル',
        'Interests': '興味・関心',
        'Skill Categories': 'スキルカテゴリ',
        'Place Categories': '場所カテゴリ',
        'Admin': 'アドミン',
        'Load More': 'もっと見る',
        'No more items to show': '表示するアイテムはもうありません',
        'Dev Info': 'ディベロッパー内容',
        'Giv Given': '贈ったGiv',
        'Giv Received': '受け取ったGiv',
        'Users who want to send giv': 'Giv贈りたい人',
        'Users who want to receive giv': 'Giv受け取りたい人',
        'Want to Giv': 'Giv贈りたい',
        'Want to Receive': 'Giv受け取りたい',
        'Create New Area': 'エリア登録',
        'Create New Time': '時間帯登録',
        'Create New Skill': 'スキル登録',
        'tag': 'タグ',
        'tagEn': 'タグ（英語）',
        'Create New Category': 'スキルカテゴリ登録',
        'Create New Place Category': '場所カテゴリ登録',
        'Register Giv': 'Giv登録',
        'Sender': 'センダー',
        'To User': 'ユーザーへ',
        'From User': 'ユーザーから',
        'Event Type': 'タイプ',
        'Read': '読みました',
        'Details': '内容',
        'Created': '登録日',
        'Area': '場所',
        'Available Times': '提供できる時間帯',
        'Search': '検索',
        'Category': 'カテゴリ',
        'Visible': 'アクティブ',
        'Create': '登録',
        'Name': '名',
        'Name (JP)': '名（日本語）',
        'Name (English)': '名（英語）',
        'Skill Name (JP)': '名（日本語）',
        'Skill Name (English)': '名（英語）',
        'Display Order': '表示順',
        'Category Name (JP)': 'カテゴリ名（日本語）',
        'Category Name (English)': 'カテゴリ名（英語）',
        'Summary (JP)': 'まとめ（日本語）',
        'Summary (English)': 'まとめ（英語）',
        'Time Name (JP)': 'まとめ（日本語）',
        'Time Name (English)': 'まとめ（英語）',
        'Area Name (JP)': '場所名（日本語）',
        'Area Name (English)': '場所名（英語）',
        'Meetup': 'ミートアップ',
        'Mail': 'メール',
        'Giver': 'ギバー',
        'Receiver': 'レシーバー',
        'Place': '場所',
        'Date': '日付',
        'Giv Type': 'Givタイプ',
        'Start Time': '開始時間',
        'End Time': '終了時間',
        'Zip': '郵便番号',
        'Edit': '更新',
        'Updated At': '更新日',
        'Update': '更新する',
        'Created At': '登録日',
        'Status': 'ステータス',
        'Activated': 'アクティブ',
    },
}

const i18n = new VueI18n({
    locale: 'ja',
    messages,
})

Vue.component('modal', Modal)
Vue.component('Button', Button)
Vue.component('v-select', vSelect)
Vue.component('collapsible', Collapsible)
Vue.component('spinner', Spinner)
Vue.component('coming-soon', ComingSoon)

new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app')
